(() => {
  function slugify(value) {
    return String(value || '')
      .toLowerCase()
      .trim()
      .replace(/[^a-z0-9\s-]/g, '')
      .replace(/\s+/g, '-')
      .replace(/-+/g, '-');
  }

  function createFaq(content) {
    const children = Array.from(content.children);
    const fragment = document.createDocumentFragment();
    const list = document.createElement('div');
    list.className = 'sg-info-page__faq-list';

    let current = null;
    let intro = [];

    children.forEach((node) => {
      if (/^H[23]$/.test(node.tagName)) {
        const details = document.createElement('details');
        details.className = 'sg-info-page__faq-item';

        const summary = document.createElement('summary');
        summary.className = 'sg-info-page__faq-summary';

        const title = document.createElement('span');
        title.textContent = node.textContent.trim();

        const icon = document.createElement('span');
        icon.className = 'sg-info-page__faq-icon';
        icon.setAttribute('aria-hidden', 'true');

        summary.append(title, icon);

        const answer = document.createElement('div');
        answer.className = 'sg-info-page__faq-answer';

        details.append(summary, answer);
        list.append(details);
        current = answer;
      } else if (current) {
        current.append(node);
      } else {
        intro.push(node);
      }
    });

    intro.forEach((node) => fragment.append(node));
    if (list.children.length) {
      fragment.append(list);
      list.querySelector('details')?.setAttribute('open', '');
    }

    content.replaceChildren(fragment);
  }

  function createToc(root, content) {
    const toc = root.querySelector('[data-sg-info-toc]');
    const list = root.querySelector('[data-sg-info-toc-list]');
    if (!toc || !list) return;

    const headings = Array.from(content.querySelectorAll('h2, h3'))
      .filter((heading) => heading.textContent.trim());

    if (headings.length < 2) {
      toc.hidden = true;
      root.querySelector('.sg-info-page__layout')?.classList.remove('sg-info-page__layout--toc');
      return;
    }

    const used = new Set();
    headings.forEach((heading, index) => {
      let id = heading.id || slugify(heading.textContent) || `section-${index + 1}`;
      let uniqueId = id;
      let suffix = 2;
      while (used.has(uniqueId) || document.getElementById(uniqueId)) {
        uniqueId = `${id}-${suffix}`;
        suffix += 1;
      }
      used.add(uniqueId);
      heading.id = uniqueId;

      const item = document.createElement('li');
      if (heading.tagName === 'H3') item.className = 'is-subsection';

      const link = document.createElement('a');
      link.href = `#${uniqueId}`;
      link.textContent = heading.textContent.trim();
      item.append(link);
      list.append(item);
    });

    toc.hidden = false;
  }

  function init(root) {
    const content = root.querySelector('[data-sg-info-content]');
    if (!content) return;

    if (root.dataset.mode === 'faq') {
      createFaq(content);
    }

    createToc(root, content);
  }

  function initAll() {
    document.querySelectorAll('[data-sg-info-page]').forEach(init);
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', initAll, { once: true });
  } else {
    initAll();
  }

  document.addEventListener('shopify:section:load', (event) => {
    event.target.querySelectorAll?.('[data-sg-info-page]').forEach(init);
  });
})();
